import { Layout } from 'antd';
import React from 'react';
import lowerLogo from 'src/assets/company-logo-with-name.svg';

const { Content } = Layout;

const PublicLayout: React.FC<React.PropsWithChildren> = (props) => {
  return (
    <Layout className='public-layout'>
      <Content className='content-container'>
        <div className='inner-container'>
          {props.children}
          <div className='lower-logo-container'>
            <img className='lower-logo' src={lowerLogo} alt='BackOffice Logo with Text' />
          </div>
        </div>
      </Content>
    </Layout>
  );
};

export default PublicLayout;
